var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTeliaAlertFilledIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#be0040",
    className: "telia-react-icon_svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 32c0 15.464-12.536 28-28 28-15.457-.017-27.983-12.543-28-28C4 16.536 16.536 4 32 4s28 12.536 28 28zM34.228 46.042a2.809 2.809 0 00-.568-1.346c-.558-.818-1.096-1.227-1.615-1.227-.402.018-.782.19-1.062.48a3.61 3.61 0 00-.867 1.3 4.417 4.417 0 00-.344 1.72c0 .758.418 1.137 1.256 1.137.776 0 1.536-.229 2.183-.658.678-.44 1.017-.908 1.017-1.406zM29.35 20.68v17.922c.001 1.033.493 1.55 1.476 1.55.93 0 1.838-.318 2.61-.912.81-.608 1.216-1.246 1.216-1.914V19.404a3.613 3.613 0 00-.638-1.779c-.663-1.154-1.328-1.731-1.993-1.731a1.75 1.75 0 00-1.216.638 4.998 4.998 0 00-1.037 1.778 6.828 6.828 0 00-.418 2.37z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTeliaAlertFilledIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/telia-alert-filled-icon.444bf3d1f5ad12be18317d613da03da1.svg";